import React from 'react';
import Pages from './Pages.js';
import { MemeOne, MemeTwo, MemeThree, MemeFour } from '../components/MemeImg.js';
// import BarLoader from 'react-spinners/ClipLoader';
// import { CSSRef } from '../components/CSSRef';

class Memes extends Pages {

    componentDidMount() {
        window.scrollTo(0, 0)
        // setTimeout(function () {
        //     this.setState({ isLoading: false });
        // }.bind(this), 5000);
    }

    renderPhoto = (obj) => {
        return (
            <div style={{textAlign: 'center', width: '90%'}} >
            {obj.map((item, index) => (
                <div  key={item.url}>
                <img src={item.url} alt='' style={{maxWidth: '90%'}}/><br/>
                </div>
            ))}

            </div>
        )
    }

    leftmenu = () => {
        return (

            <div className='leftmenu'>
                <div>Meme Gallery</div>
                <br />
                <button onClick={() => this.scroll(this.firstRef)} className={'section'}> iGEM Faux Pas </button>

                <button onClick={() => this.scroll(this.secondRef)} className={'section'}> Lab Struggles </button>

                <button onClick={() => this.scroll(this.thirdRef)} className={'section'}> Fumbling with Funding </button>

                <button onClick={() => this.scroll(this.fourthRef)} className={'section'}> Shattered dreams of a relaxed Summer</button>

            </div>
        )
    }
    righttext = () => {
        return (
            <>
                <div className='righttext'>
                    The Meme Gallery is a continuation of the project that last year's team started.
                    <br/><br/>
                    To our team, memes serve as a form of documentation. It is a way to entertain our teammates while coping with the ups and downs of conducting an iGEM project. Through memes, we communicate inside jokes, recording mundane moments and turning them into memorable ones. 
                    <br/><br/>
                    We also created memes that hopefully resonate with researchers and fellow iGEMers regarding unprecedented situations that may have occurred in labs and other funny moments during research that science enthusiasts may find entertaining. 
                    <br/><br/>
                    Below is a collection of memes that were created by HKU iGEM 2022. We had a lot of fun creating this gallery and we hope you enjoyed it as much as we did.
                    <br/><br/>
                    <h2 ref={this.firstRef}>iGEM Faux Pas</h2><br/>
                    {this.renderPhoto(MemeOne)}
                    <br/><br/>
                    <h2 ref={this.secondRef}>Lab Struggles</h2><br/>
                    {this.renderPhoto(MemeTwo)}
                    <br/><br/>
                    <h2 ref={this.thirdRef}>Fumbling with Funding</h2><br/>
                    {this.renderPhoto(MemeThree)}
                    <br/><br/>
                    <h2 ref={this.fourthRef}>Shattered dreams of a relaxed Summer</h2><br/>
                    {this.renderPhoto(MemeFour)}

                </div>
            </>
        )
    }

    render() {
        return (
            <>
            {/* {this.state.isLoading ? <div className='load-container'><BarLoader color={'silver'} size={150} loading={this.state.isLoading} cssOverride={CSSRef} /></div> : null} */}
                <h1 className='des'>Meme Gallery</h1>
                <div className='pageholder'>

                    {this.leftmenu()}
                    {this.righttext()}
                </div>
            </>
        )
    }
}


export default Memes;
